import axios from 'axios';

/**
 * Gets the current user's PV period info from the server and returns it
 */
export default async function getCurrentUserPvPeriod(): Promise<{
  showPvPeriod: boolean;
  pvPeriodText: string;
}> {
  const response = await axios.get('/api/checkout/profile/current');
  const showPvPeriod = Boolean(
    response.data.data.isDistributor && response.data.data.pvPeriod
  );
  let pvPeriodText = null;
  if (response.data.data.pvPeriod) {
    const unformatted = response.data.data.pvPeriod;
    pvPeriodText =
      unformatted.substring(4, 6) + '/' + unformatted.substring(0, 4);
  }
  return { showPvPeriod: showPvPeriod, pvPeriodText: pvPeriodText };
}
